import {
    BORDER_PC_LINE,
    DATELIST_HEIGHT_MOBILE,
    DATELIST_HEIGHT_PC,
    DIVICE_PC_WIDTH,
    MOBILE_CNB_HEIGHT,
    PC_CNB_HEIGHT,
} from '@utils/constants';
import { addDays, format } from 'date-fns';

export const goNowTime = (delayTime: number = 1500) => {
    setTimeout(() => {
        const targetEl = document.querySelector('.active-time');
        const isNcPurple = !!document.querySelector('body')?.classList.contains('ncPurple');
        const scrollTarget = isNcPurple ? document.querySelector('div.container') : window;
        const elScroll: number | undefined = scrollTarget instanceof Window ? scrollTarget.scrollY : scrollTarget?.scrollTop;

        if (targetEl) {
            const marginHeight =
                window.innerWidth < DIVICE_PC_WIDTH
                    ? MOBILE_CNB_HEIGHT + DATELIST_HEIGHT_MOBILE
                    : (!isNcPurple ? PC_CNB_HEIGHT : 0) + DATELIST_HEIGHT_PC - BORDER_PC_LINE;

            if (elScroll !== undefined) {
                scrollTarget?.scrollTo({
                    top: elScroll + targetEl.getBoundingClientRect().top - marginHeight,
                    behavior: 'smooth',
                });
            }
        }
    }, delayTime);
};

export function getWeekDates() {
    const today = new Date();
    const weekDates = Array.from({ length: 7 }, (_, i) => format(addDays(today, i), 'yyyy-MM-dd'));
    return weekDates;
}
